module.exports = __webpack_public_path__ + "static/media/warning-icon.379a9496.svg";